var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.975715 0.167464C0.752859 -0.0553925 0.391146 -0.0553925 0.167433 0.167464C-0.0562801 0.39032 -0.055423 0.752033 0.167433 0.975746L0.975715 0.167464ZM4.00056 4.00059L3.59685 4.4043C3.8197 4.62716 4.18142 4.62716 4.40513 4.4043L4.00056 4.00059ZM7.83283 0.975746C8.05568 0.75289 8.05568 0.391177 7.83283 0.167464C7.60997 -0.0562496 7.24826 -0.0553925 7.02455 0.167464L7.83283 0.975746ZM0.167433 0.975746L3.59685 4.4043L4.40427 3.59602L0.975715 0.167464L0.167433 0.975746ZM4.40427 4.4043L7.83283 0.975746L7.02455 0.167464L3.59599 3.59602L4.40427 4.4043Z",
    fill: "#2D3546"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.3427a6fd887de771d2ed29366e1700bb.svg";
export { ForwardRef as ReactComponent };